import React from 'react'
import { connect } from "react-redux";
import ServerSideDataTable from "../../../layouts/DataTables/ServerSideDataTable/ServerSideDataTable";
import { useEffect, useState, useRef } from "react";
import { useParams } from 'react-router-dom'
import {
  Container,
  Col,
  Row,
  Overlay,
  Button,
  Popover,
  Modal,
  Image,
} from "react-bootstrap";
import { 
  getVFODailyVistSummaries,
  getSingleVFOVisit
} from "./VFODailyVistSummariesAction";
import { VzPageContainer } from "../../../layouts/VzPageContainer";
import Moment from "react-moment";
import moment from 'moment'
import FormikControl from "../../../layouts/Input/FormikControl";
import { Formik, Form } from "formik";
import { Link } from "react-router-dom";

import axios from '../../../apis/Api'
import { toast } from 'react-toastify'
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import { useDispatch } from 'react-redux'
 
const VFODailyVistSummaries = (props) => {
    const dispatch = useDispatch()
    const { vfoId, visitDate } = useParams()
    const [currentIndex, setCurrentIndex] = useState();
    const [currentPageNo, setCurrentPageNo] = useState(0);
    const [currentPageSize, setCurrentPageSize] = useState(5);
    const [searchText, setSearchText] = useState("");
    const [show, setShow] = useState();
    const [target, setTarget] = useState();
    const [isView, setIsView] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const ref = useRef(null);
    const printRef = useRef();
    const [filter, setfilter] = useState({
      shopName: null,
      vizId: null,
      shopCode: null,
      vfoName: null,
      status: 0,
      searchText: "",
      pageSize: 5,
      pageNo: 0,
      currentDate: visitDate,
      userId:vfoId,
    });
    const modalInitialValues = {
      id: "",
      date: "",
      vizShopName: "",
      cnic: "",
      shopLat: "",
      visitedLat: "",
      visitedLong: "",
      address: "",
      remarks: "",
      vizId: "",
      ownerName: "",
      shopLong: ""
    };
    const [vfoModelState, setVfoModelState] = useState(modalInitialValues);
useEffect(() => {
  let param =filter;
  if(searchText){
    debugger;
    param.searchText= searchText;
    
  }
    props.getVFODailyVistSummaries(filter);
  }, []);
    
const LoadDataByfilter=()=>{
  setShow(false);
  setTarget(null);
  let requestFilter = {
    shopName: filter.shopName,
    vizId: filter.vizId,
    shopCode: filter.shopCode,
    vfoName: filter.vfoName,
    status:filter.status?.value,
    searchText: searchText,
    pageSize: 5,
    pageNo: 0,
    currentDate: visitDate,
    userId:vfoId,
  }
  //requestFilter.status= requestFilter.status?.value;
  props.getVFODailyVistSummaries(requestFilter);
}
const checkInStatus = [
  {
    label: "Pending",
    value: 1,
  },
  {
    label: "Rejected",
    value: 2,
  },
  {
    label: "Approved",
    value: 3,
  }
];


    const columns = [
        {
          Header: "VIZ ID",
          accessor: "vizId",
        },
        {
          Header: "Shop Code",
          accessor: "shopCode",
        },
        {
          Header: "Shop Name",
          accessor: "shopName",
        },
        {
          Header: "VFO Name",
          accessor: "vfoName",
        },
        {
          Header: "Remarks",
          accessor: "remarks",
        },
        {
          Header: "Status",
          accessor: "getStatus",
        },
        {
          Header: "Action",
          id: "edit",
          accessor: "id",
          Cell: ({ row: { original } }) => (
            <div style={{ width: "106px" }}>
              <button 
                onClick={() =>  viewRecord(original.id)} 
                className=" btn btn-sm">
                <i className="fas fa-eye"></i>
              </button>
              &nbsp;
              <button
                style={{display:(original.status==1?'inline':'none')}}
                onClick={() => editRecord(original.id)}
                className="btn btn-sm"
              >
                <i className="fas fa-edit"></i>
              </button> 
            </div>
          ),
        },
      ];

      const getData=(page)=>{
        setCurrentPageNo(page);
        let filterReq=filter;
        filter.pageNo=page;
        filterReq.status=filter.status?.value;
        props.getVFODailyVistSummaries(filterReq);

      }
      const pageSizeChanged=(size)=>{
        setCurrentPageNo(0);
        setCurrentPageSize(size);
        let filterReq=filter;
        filterReq.pageNo=0;
        filterReq.pageSize=size;
        filterReq.status=filter.status?.value;
        props.getVFODailyVistSummaries(filterReq);
      }
      const searchChanged=(searchText)=>{
        let param =filter;
        param.searchText= searchText;
        filter.pageNo=0;
        props.getVFODailyVistSummaries(filter);
      }
      const openFilterModal = (event) => {
        setShow(!show);
        setTarget(event.target);
      };
      const handleResetFilters = (resetForm) => {
        resetForm();
        setfilter({
          shopName: "",
          vizId: "",
          shopCode: "",
          vfoName: "",
          status: 0,
          searchText: "",
          pageNo: 0,
          currentDate: visitDate,
          userId:vfoId,
        });
        setCurrentIndex(0);
       // setCurrentPageSize(0);
        setCurrentPageNo(0);
      };

const viewRecord = (id) => {
  props.getSingleVFOVisit(id);
  setIsView(true);
  setIsEdit(false);
};

const editRecord = (id) => {
  props.getSingleVFOVisit(id);
  setIsView(false);
  setIsEdit(true);
};

const closeModal = () => {
  setIsView(false);
  setIsEdit(false);
};

const ChangeStatus=(id,status)=>{

    dispatch(showLoading())
    axios
      .post(`api/VizShopCheckIn/ChangeSingleVFOVisitStatus/${id}/${status}`)
      .then(({ data }) => {
        debugger;
        if(data.response != null){
        toast.success('Visit Status Changed Successfully');
        let currentlist = props.VFOVisitDetailList.filter(x=>x.id == data.response);
        if(currentlist.length>0){
        currentlist[0].status=status;
        currentlist[0].getStatus=(status==2?"Rejected":"Approved");
        }
        }else{
          toast.error('Error while processing the request');
        }
        closeModal();
        dispatch(hideLoading())
      })
      .catch(function (error) {
        toast.success(error);
        dispatch(hideLoading())
      })
}

useEffect(()=>{
  if(props.SingleVFODetail){
  setVfoModelState({
    id: props.SingleVFODetail.id??'',
    date: props.SingleVFODetail.visitDate,
    vizShopName: props.SingleVFODetail.vizShopName,
    cnic: props.SingleVFODetail.cnic,
    shopLat: props.SingleVFODetail.shopLat??'',
    shopLong: props.SingleVFODetail.shopLong??'',
    visitedLat: props.SingleVFODetail.visitedLat??'',
    visitedLong: props.SingleVFODetail.visitedLong??'',
    address: props.SingleVFODetail.address,
    remarks:props.SingleVFODetail.remarks,
    vizId: props.SingleVFODetail.vizId,
    ownerName:props.SingleVFODetail.ownerName,
  });
  }
},[props.SingleVFODetail])
    return (
    <div>
     <VzPageContainer title="VFO Module > VFO Visit List">
     <Row>
          <Col style={{ float: "left" }}>
            <h4>
              <b>VFO Visit List</b>
            </h4>
            <br />
          </Col>
     </Row>
     <Row>
          <Col md={10} style={{ float: "right" }}>
            <div ref={ref}>
              <Button
                onClick={openFilterModal}
                className="m-3"
                variant="outline-primary"
              >
                <i className="fa fa-filter" />
                Filters
              </Button>

              <Overlay
                show={show}
                target={target}
                placement="bottom"
                container={ref}
                containerPadding={20}
                width="430px"
                style={{ width: "430px" }}
              >
                <Popover
                  id="popover-contained"
                  style={{ maxWidth: "360px", width: "360px" }}
                >
                  <Popover.Header as="h3">Filters</Popover.Header>
                  <Popover.Body>
                    <Formik
                      enableReinitialize
                      initialValues={filter}
                      validator={() => ({})}
                      onSubmit={LoadDataByfilter}
                    >
                      {(formik) => (
                        <Form autoComplete="off">
                          <Row>
                          <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="input"
                                type="text"
                                label="Shop Code"
                                name="shopCode"
                                handleOnChange={(e) => {
                                  filter.shopCode = e;
                                  setfilter({ ...filter, shopCode: e });
                                }}
                                value={filter.shopCode}
                              />
                            </Col>
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="input"
                                type="text"
                                label="VIZ ID"
                                name="vizId"
                                handleOnChange={(e) => {
                                  filter.vizId = e;
                                  setfilter({ ...filter, vizId: e });
                                }}
                                value={filter.vizId}
                              />
                            </Col>
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="input"
                                type="text"
                                label="Shop Name"
                                name="shopname"
                                handleOnChange={(e) => {
                                  filter.shopName = e;
                                  setfilter({ ...filter, shopName: e });
                                }}
                                value={filter.shopName}
                              />
                            </Col>
                            <Col xs={12} md={12}>
                              <FormikControl
                                formik={formik}
                                control="input"
                                type="text"
                                label="VFO"
                                name="vfo"
                                handleOnChange={(e) => {
                                  filter.vfoName = e;
                                  setfilter({ ...filter, vfoName: e });
                                }}
                                value={filter.vfoName}
                              />
                            </Col>
                            <Col xs={12} md={12}>
                                <FormikControl
                                  formik={formik}
                                  control="react-select"
                                  label="Status"
                                  name="status"
                                  options={checkInStatus}
                                  isClearable={true}
                                  isSearchable={true}
                                  handleOnChange={(e) => {
                                    if (!e || !e.value) {
                                      setfilter({
                                        ...filter,
                                        status: 0,
                                      });
                                      return;
                                    }
                                    setfilter({
                                      ...filter,
                                      status: {
                                        label: e.label,
                                        value: e.value,
                                      },
                                    });
                                  }}
                                   value={filter.status}
                                />
                              </Col>
                          </Row>
                          <div className="row" style={{ marginTop: 20 }}>
                            <div className="form-group">
                              <Link
                                onClick={handleResetFilters.bind(
                                  null,
                                  formik.resetForm,
                                )}
                                to="#"
                                className="active"
                                style={{
                                  padding: "0px",
                                  marginTop: "10px",
                                  float: "left",
                                }}
                              >
                                Reset
                              </Link>
                              <Link
                                onClick={() => {
                                  setShow(false);
                                  setTarget(null);
                                }}
                                to="#"
                                className="active"
                                style={{
                                  padding: "0px",
                                  marginTop: "10px",
                                  float: "right",
                                }}
                              >
                                Cancel
                              </Link>
                              <div className="float-right">
                                <Button
                                  type="submit"
                                  className="btn btn-primary"
                                  style={{
                                    marginRight: "10px",
                                    float: "right",
                                  }}
                                >
                                  Apply
                                </Button>
                              </div>
                            </div>
                          </div>
                        </Form>
                      )}
                    </Formik>
                  </Popover.Body>
                </Popover>
              </Overlay>
            </div>
          </Col>
        </Row>
     <Row>
     <Col>
            <ServerSideDataTable
              data={props.VFOVisitDetailList ?? []}
              columns={columns}
              getTrProps={(event, data) => null}
              goToPreviousPage={(val) => getData(val)}
              goToNextPage={(val) => getData(val)}
              totalRecords={props.TotalRows}
              pageSizeChange={(size) => pageSizeChanged(size)}
              myPageSize={currentPageSize}
              myIndex={currentIndex}
              pageNo={currentPageNo}
              searchChanged={searchChanged}
            />
          </Col>
     </Row>
     <Modal
          show={isView || isEdit}
          onHide={closeModal}
          backdrop="static"
          keyboard={false}
          size="xl"
        >
          <Formik
            enableReinitialize
            initialValues={modalInitialValues}
            validationSchema={null}
            // onSubmit={saveData}
          >
            {(formik) => (
              <Form autoComplete="off">
                <Modal.Header closeButton>
                  <Modal.Title id="contained-modal-title-vcenter">
                    VFO Visited Form
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body ref={printRef}>
                    <Row>
                      <Col md={10} sm={12}>
                        <Row>
                          <div className="d-flex justify-content-between mx-2 align-items-center">
                            <Col xs={2} className="text-right">
                              Date:
                            </Col>
                            <Col xs={4}>
                              <div className="form-group">
                              <FormikControl
                                  formik={formik}
                                  control="input"
                                  type="vfoDate"
                                  name="vfoDate"
                                  readOnly="true"
                                  value={moment(vfoModelState.date).format('DD/MM/YYYY hh:mm A')}
                                />
                              </div>
                            </Col>
                            <Col xs={2} className="text-right">
                              VIZ ID:
                            </Col>
                            <Col xs={4}>
                              <div className="form-group">
                                <FormikControl
                                  formik={formik}
                                  control="input"
                                  type="vizId"
                                  name="vizId"
                                  readOnly="true"                                 
                                  value={vfoModelState.vizId}
                                />
                              </div>
                            </Col>
                          </div>
                        </Row>
                        <Row>
                          <div className="d-flex justify-content-between mx-2 align-items-center">
                            <Col xs={2} className="text-right">
                              VIZ Shop Name:
                            </Col>
                            <Col xs={4}>
                              <div className="form-group">
                                <FormikControl
                                  formik={formik}
                                  control="input"
                                  type="vizShopName"
                                  name="vizShopName"
                                  readOnly="true"
                                  value={vfoModelState.vizShopName}
                                />
                              </div>
                            </Col>
                            <Col xs={2} className="text-right">
                             Owner Name:
                            </Col>
                            <Col xs={4}>
                              <div className="form-group">
                                <FormikControl
                                  formik={formik}
                                  control="input"
                                  type="ownerName"
                                  name="ownerName"
                                  readOnly="true"
                                  value={vfoModelState.ownerName}
                                />
                              </div>
                            </Col>
                          </div>
                        </Row>
                        <Row>
                          <div className="d-flex justify-content-between mx-2 align-items-center">
                            <Col xs={2} className="text-right">
                             CNIC #:
                            </Col>
                            <Col xs={4}>
                              <div className="form-group">
                                <FormikControl
                                  formik={formik}
                                  control="input"
                                  type="cnic"
                                  name="cnic"
                                  readOnly="true"
                                  value={vfoModelState.cnic}
                                />
                              </div>
                            </Col>
                            <Col xs={2} className="text-right">
                            Shop Long:
                            </Col>
                            <Col xs={4}>
                              <div className="form-group">
                                <FormikControl
                                  formik={formik}
                                  control="input"
                                  type="shopLong"
                                  name="shopLong"
                                  readOnly="true"
                                  value={vfoModelState.shopLong}
                                />
                              </div>
                            </Col>
                          </div>
                        </Row>
                        <Row>
                          <div className="d-flex justify-content-between mx-2 align-items-center">
                            <Col xs={2} className="text-right">
                            Shop Lat:
                            </Col>
                            <Col xs={4}>
                              <div className="form-group">
                                <FormikControl
                                  formik={formik}
                                  control="input"
                                  type="shopLat"
                                  name="shopLat"
                                  readOnly="true"
                                  value={vfoModelState.shopLat}
                                />
                              </div>
                            </Col>
                            <Col xs={2} className="text-right">
                              Visited Long:
                            </Col>
                            <Col xs={4}>
                              <div className="form-group">
                                <FormikControl
                                  formik={formik}
                                  control="input"
                                  type="visitedLong"
                                  name="visitedLong"
                                  readOnly="true"
                                  value={vfoModelState.visitedLong}
                                />
                              </div>
                            </Col>
                          </div>
                        </Row>
                        <Row>
                          <div className="d-flex justify-content-between mx-2 align-items-center">
                            <Col xs={2} className="text-right">
                            Visited Lat:
                            </Col>
                            <Col xs={4}>
                              <div className="form-group">
                                <FormikControl
                                  formik={formik}
                                  control="input"
                                  type="visitedLat"
                                  name="visitedLat"
                                  readOnly="true"
                                  value={vfoModelState.visitedLat}
                                />
                              </div>
                            </Col>
                            <Col xs={6}>
                            </Col>
                          </div>
                        </Row>
                        <Row>
                          <div className="d-flex justify-content-between mx-2 align-items-center">
                            <Col xs={2} className="text-right">
                            Address:
                            </Col>
                            <Col xs={8}>
                              <div className="form-group">
                                <FormikControl
                                  formik={formik}
                                  control="input"
                                  type="address"
                                  name="address"
                                  readOnly="true"
                                  value={vfoModelState.address}
                                />
                              </div>
                            </Col>
                            <Col xs={2}>
                            </Col>
                          </div>
                        </Row>
                        <Row>
                          <div className="d-flex justify-content-between mx-2 align-items-center">
                            <Col xs={2} className="text-right">
                            Remarks:
                            </Col>
                            <Col xs={8}>
                              <div className="form-group">
                                <FormikControl
                                  formik={formik}
                                  control="textarea"
                                  row="2"
                                  type="remarks"
                                  style={{resize: 'none'}}
                                  name="remarks"
                                  readOnly="true"
                                  value={vfoModelState.remarks}
                                />
                              </div>
                            </Col>
                            <Col xs={2}>
                            </Col>
                          </div>
                        </Row>
                      </Col>
                    </Row>
                 
                </Modal.Body>
                {isEdit ? (
                  <Modal.Footer className="">
                       <div>
                         <Button className="btn btn-default" 
                         onClick={()=>ChangeStatus(vfoModelState.id,2)}>
                         Rejected Visit
                         </Button> 

                         <Button
                          onClick={()=>ChangeStatus(vfoModelState.id,3)}
                          className="btn btn-primary mx-4">
                          Approved Visit
                        </Button>
                      </div>
                    
                  </Modal.Footer>
                  ):(
                  <div></div>
                  )}
           
              </Form>
            )}
          </Formik>
        </Modal>
    </VzPageContainer>
    </div>
    );
}
const mapStateToProps = (state) => {
  return {
    VFOVisitDetailList: state.VFOVisitDetailList?state.VFOVisitDetailList.VFOVisitDetailList?.records:[],
    TotalRows: state.VFOVisitDetailList?state.VFOVisitDetailList.VFOVisitDetailList?.totalRow:0,
    SingleVFODetail:state.SingleVFODetail.SingleVFODetail?state.SingleVFODetail.SingleVFODetail:null
  };
};
export default connect(mapStateToProps, {getVFODailyVistSummaries,getSingleVFOVisit})(VFODailyVistSummaries); 
